$mol_icon_arrow_down_bold $mol_icon path \M9,4H15V12H19.84L12,19.84L4.16,12H9V4Z
